export default __webpack_public_path__ + "static/media/i024vp.844751f1.webp";